import { render, staticRenderFns } from "./preguntasFrecuentes.vue?vue&type=template&id=58ee5aca&scoped=true"
import script from "./preguntasFrecuentes.vue?vue&type=script&lang=js"
export * from "./preguntasFrecuentes.vue?vue&type=script&lang=js"
import style0 from "./preguntasFrecuentes.vue?vue&type=style&index=0&id=58ee5aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee5aca",
  null
  
)

export default component.exports